module.exports = __webpack_public_path__ + "static/media/ico-bpay.448ce47a.svg";